export default "__VITE_ASSET__TdvPBDBX__"